module.exports = __webpack_public_path__ + "static/media/ragyoka-icon.80767fee.svg";